import { Cookies } from 'react-cookie';

const writeDebugLog = (message: string) => {
  const cookies = new Cookies();
  const hasDebugCookie = cookies.get('wavetrak-debug') === 'true';
  if (hasDebugCookie) {
    console.log(`WT-Debug: ${message}`);
  }
};

export default writeDebugLog;
